import { ref, reactive, onBeforeMount, watch } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import documentModel from "@/models/document/document";

import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useSetTimeInterval from "@/utils/hooks/useSetTimeInterval";
export default function useDocumentDetail() {
  const { onSetTimeInterval } = useSetTimeInterval();

  const { fetchDocumentList } = documentModel();
  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const { filters, onSelectFilter } = useFilterHeaderTable();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
  } = useValidationModal();

  const loading = reactive({
    tableData: false,
  });

  const form = reactive({
    validFromDate: null,
    validFromTime: null,
    validThroughDate: null,
    validThroughTime: null,
    status: null,
  });

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateString,
  } = useFlatPickr();

  const fields = [
    { key: "seq", label: "No" },
    { key: "documentno", label: "Document ID" },
    // { key: "image", label: "Image" },
    { key: "name", label: "Customer Name" },
    { key: "mobileno", label: "Mobile No." },
    { key: "time", label: "Date time" },
    { key: "approve_by", label: "Admin" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const statusOption = ref([
    { label: "Pending", value: 1 },
    { label: "Complete", value: 5 },
    { label: "Reject", value: 9 },
  ]);

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 5:
        return "Complete";
      case 9:
        return "Reject";
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "pending-status";
      case 5:
        return "complete-status";
      case 9:
        return "reject-status";
    }
  };

  const status = ref(0);

  const documentDetailTable = reactive({
    payload: [],
  });

  const onSelectDocumentFilter = (key, value) => {
    onSelectFilter(key, value ? value : null);
  };

  const getDocumentList = (showLoading = true, pagin = false) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchDocumentList.payload.Container_Id = router.currentRoute.params.ref;
    fetchDocumentList.payload.FromDate =
      form.validFromDate?.replaceAll("-", "/") || null;
    fetchDocumentList.payload.FromTime = form.validFromTime;
    fetchDocumentList.payload.ToDate =
      form.validThroughDate?.replaceAll("-", "/") || null;
    fetchDocumentList.payload.ToTime = form.validThroughTime;
    fetchDocumentList.payload.Page = pagin ? 1 : pagination.currentPage;
    fetchDocumentList.payload.Limit = pagination.perPage;
    fetchDocumentList.payload.Filters = filters;
    store
      .dispatch("api/apiRequest", fetchDocumentList)
      .then((response) => {
        documentDetailTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const routeDocumentInfo = (documentId) => {
    if (localStorage.getItem("activeTab") !== null) {
      localStorage.removeItem("activeTab");
    }
    return (
      "/campaign/info/" +
      documentId +
      "?brandRef=" +
      sessionStorage.getItem(window.brandSessionStorage)
    );
  };

  const getDateTimeNow = () => {
    return new Promise((resolve) => {
      var today = new Date();
      var tomorrow = new Date(today);
      today.setDate(today.getDate() - 30);
      tomorrow.setDate(tomorrow.getDate() + 1);
      form.validFromDate =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      form.validThroughDate =
        String(tomorrow.getDate()).padStart(2, "0") +
        "-" +
        String(tomorrow.getMonth() + 1).padStart(2, "0") +
        "-" +
        tomorrow.getFullYear();
      form.validFromTime = "00:00";
      form.validThroughTime = "00:00";
      resolve("success");
    });
  };

  onBeforeMount(() => {
    getDateTimeNow()
      .then(() => {
        getDocumentList();
      })
      .catch(() => {});
  });

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        getDocumentList();
      }
    },
    { deep: true }
  );

  return {
    fields,
    loading,
    statusOption,
    status,
    documentDetailTable,
    pagination,
    onPageChange,
    onFilterEntity,
    resolveStatusLabel,
    resolveStatusClass,
    getDocumentList,
    onSelectDocumentFilter,
    routeDocumentInfo,
    form,
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateString,
  };
}
